import * as Utils from "../utils/Config";
import { ApiClient } from "./ApiClient";
import { IOrganisation } from "../models/IOrganisation";
import { ICounterPart } from "../models/ICounterPart";
import { ISector } from "../models/ISector";
import { IOrganisationClinic } from "../models/IOrganisationClinic";

export class OrganisationApi extends ApiClient {

    getOrganisationById(organisationId: number, success: (data: IOrganisation) => void, error?: (message: string) => void, final?: () => void) {
        this.get<IOrganisation>(`${Utils.MEN_PORTAL_API_BASE_URL}/organisations/${organisationId}`, success, error, final);
    }
    
    getCounterParts(success: (data: ICounterPart[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get(`${Utils.MEN_PORTAL_API_BASE_URL}/organisations/getCounterParts`, success, error, final);
    }

    getSectors(success: (data: ISector[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get(`${Utils.MEN_PORTAL_API_BASE_URL}/organisations/getSectors`, success, error, final);
    }

    getOrganisationsListItems(success: (data: IOrganisationClinic[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get(`${Utils.MEN_PORTAL_API_BASE_URL}/organisations/getOrganisationsListItems`, success, error, final);
    }
    updateOrganisation(data: IOrganisation, success: () => void, error?: (message: string) => void, final?: () => void) {
        this.put(`${Utils.MEN_PORTAL_API_BASE_URL}/organisations`, data, success, error, final);
    }
}

